import { mapState } from 'vuex';
import { isNullOrEmpty } from '../../../../../../utils/vuex';
import get from 'lodash/get';

import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';

export default {
  components: {
    codemirror,
  },
  props: {
    otherStates: {
      type: Array,
      required: false,
      default: () => [],
    },
    // is this an 'edit', 'create', or mass-variable- 'import'?
    mode: {
      type: String,
      required: false,
      default: () => 'edit',
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      cmLineNumbers: false,

      selectedVirtualDeviceState: [],
      aggregateStateValue: '',
      virtualDeviceVariableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [
          20,
          50,
          {
            text: this.$i18n_t('Common.all'),
            value: -1,
          },
        ],
      },
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    hasManageAllPermissions() {
      return this.permissions['all.manage'];
    },

    requiredRule() {
      return [(v) => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    virtualDeviceVariableHeaders() {
      return [
        {
          sortable: true,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.key'),
          value: 'key',
          align: 'left',
        },
      ]
        .concat(
          this.usage !== 'device-type' && !this.templateContext
            ? [
                {
                  sortable: true,
                  text: this.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
                  value: 'value.value',
                  align: 'left',
                },
                {
                  sortable: true,
                  text: this.$i18n_t('DigitalTwin.DigitalTwin.states.lastUpdate'),
                  value: 'milliseconds_ago',
                  align: 'left',
                },
              ]
            : []
        )
        .concat([
          {
            sortable: true,
            text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
            value: 'properties.unit',
            align: 'left',
          },
        ]);
    },
    cmOptions() {
      return {
        tabSize: 4,
        mode: { name: 'javascript', json: true },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: this.cmLineNumbers,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false,
        },
        lineWrapping: false,
      };
    },
    // virtualDeviceConfigStates, to be implemented by component
    // stateObjects, to be implemented by component
  },
  watch: {
    selectedVirtualDeviceState() {
      this.emitSelection();
    },
    stateObjects() {
      this.recalcSelectedStates();
    },
  },
  mounted() {
    if (this.mode !== 'create' && this.mode !== 'import' && this.virtualDeviceConfigStates) {
      this.recalcSelectedStates();
    }
  },
  methods: {
    get,
    isNullOrEmpty,
    refreshForm() {
      setTimeout(() => {
        if (this.$refs.codemirror) {
          // required workaround to get the cursor appearing at the right spot
          // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
          this.$refs.codemirror.codemirror.refresh();
          this.$refs.codemirror.codemirror.focus();
        }
      }, 50);
    },
    onCmFocus() {
      this.refreshForm();
      this.cmLineNumbers = true;
    },
    recalcSelectedStates() {
      const stateObjects = this.stateObjects || [];
      this.selectedVirtualDeviceState = this.virtualDeviceConfigStates
        .map((state) => {
          // mapStateToPersistRepresentation, to be implemented by component
          if (this.mapStateToPersistRepresentation) {
            return this.mapStateToPersistRepresentation(state);
          }
          // as fallback, assume the `state` is an ID and can be identified with such from `stateObjects`
          return stateObjects.find((sO) => (sO.id || sO.key) === state);
        })
        .filter((s) => s);
    },
    mapStateToUi(state) {
      if (get(state, 'value.time')) {
        state['milliseconds_ago'] = new Date() - new Date(state.value.time);
        state['time_ago'] = state['milliseconds_ago'];

        const units = ['seconds', 'minutes', 'hours', 'days', 'months'];
        const conversion = [1000, 60, 60, 24, 30];
        let selectedUnit = 0;
        while (state['time_ago'] >= conversion[selectedUnit] && selectedUnit < conversion.length) {
          state['time_ago'] = Math.floor(state['time_ago'] / conversion[selectedUnit]);
          selectedUnit++;
        }
        selectedUnit--;
        if (selectedUnit >= 0) {
          state['time_ago'] = `${state['time_ago']} ${units[selectedUnit]}`;
        }
      }
      return state;
    },
  },
};
